import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { LoadingComplete, LoadingStart } from './loading.actions';

export interface LoadingStateModel {
  loading: boolean;
}

@State<LoadingStateModel>({
  name: 'loading',
  defaults: {
    loading: false,
  },
})
@Injectable()
export class LoadingState {
  @Selector()
  static getState(state: LoadingStateModel): LoadingStateModel {
    return state;
  }

  @Selector()
  static getLoading(state: LoadingStateModel): boolean {
    return state.loading;
  }

  @Action(LoadingStart)
  loadingStart(ctx: StateContext<LoadingStateModel>): void {
    const stateModel = ctx.getState();
    ctx.setState({
      ...stateModel,
      loading: true,
    });
  }

  @Action(LoadingComplete)
  loadingComplete(ctx: StateContext<LoadingStateModel>): void {
    const stateModel = ctx.getState();
    ctx.setState({
      ...stateModel,
      loading: false,
    });
  }
}
